import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
  updateDoc,
} from "firebase/firestore";
import { db } from '../../../../firebaseConfig';

export async function fetchTutors() {
  const q = query(collection(db, "users"), where("role", "in", ["tutor", "admin"]));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export async function fetchTutorById(uid) {
  const ref = doc(db, "users", uid);
  const snap = await getDoc(ref);
  if (!snap.exists()) return null;
  return { id: snap.id, ...snap.data() };
}

export async function updateTutorStatus(uid, status) {
  const s = String(status || "active").trim().toLowerCase();
  await updateDoc(doc(db, "users", uid), { status: s });
}

export async function saveTutor(uid, data) {
  const clean = {};
  for (const [k, v] of Object.entries(data || {})) {
    if (v !== undefined) clean[k] = v;
  }

  if (clean.status !== undefined) {
    clean.status = String(clean.status || "active").trim().toLowerCase();
  }

  await updateDoc(doc(db, "users", uid), clean);
}
